export var ControlSize;
(function (ControlSize) {
  ControlSize["small"] = "sm";
  ControlSize["normal"] = "";
  ControlSize["large"] = "lg";
})(ControlSize || (ControlSize = {}));